import { render, staticRenderFns } from "./holidayArrange.vue?vue&type=template&id=3d676ace&scoped=true"
import script from "./holidayArrange.vue?vue&type=script&lang=js"
export * from "./holidayArrange.vue?vue&type=script&lang=js"
import style0 from "./holidayArrange.vue?vue&type=style&index=0&id=3d676ace&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d676ace",
  null
  
)

export default component.exports